import { useMediaQuery, useTheme } from '@mui/material';

export const useResponsive = () => {
  const theme = useTheme();

  // 브레이크포인트별 반응형 상태
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));

  // 범위별 반응형 상태
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  // 그리드 컬럼 수 계산
  const getGridCols = () => {
    if (isSmallScreen) return 1;
    if (isMediumScreen) return 2;
    return 4;
  };

  // 사이드바 너비 계산
  const getSidebarWidth = () => {
    if (isMobile) return 0;
    if (isTablet) return 240;
    return 280;
  };

  // 메인 콘텐츠 여백 계산
  const getMainContentMargin = () => {
    if (isMobile) return 0;
    if (isTablet) return 240;
    return 280;
  };

  // 카드 높이 계산
  const getCardHeight = () => {
    if (isSmallScreen) return 300;
    if (isMediumScreen) return 350;
    return 400;
  };

  // 차트 높이 계산
  const getChartHeight = () => {
    if (isSmallScreen) return 250;
    if (isMediumScreen) return 300;
    return 350;
  };

  return {
    // 개별 브레이크포인트
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    
    // 범위별 상태
    isMobile,
    isTablet,
    isDesktop,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    
    // 유틸리티 함수들
    getGridCols,
    getSidebarWidth,
    getMainContentMargin,
    getCardHeight,
    getChartHeight,
    
    // 현재 화면 크기 정보
    currentBreakpoint: isSmallScreen ? 'xs' : 
                      isMediumScreen ? 'md' : 'lg',
  };
};
